module.exports = __webpack_public_path__ + "img/组 16 拷贝.c20f51e7.png";